(ns common.i18n.translate
  (:require [clojure.string]
            [common.i18n.icu]
            [common.i18n.dictionary :refer [dictionaries]]
            [tongue.core :as tongue])
  #?(:cljs (:require-macros [common.i18n.translate])))

(def translate (tongue/build-translate dictionaries))

#?(:clj
   (defn throw-for-missing-key
     [{:keys [enforced-locales item-key]}]
     (doall
       (for [locale enforced-locales]
         (let [flat-dictionary (common.i18n.dictionary/build-dict
                                 (get common.i18n.dictionary/dictionaries locale))]
           (when (not (contains? flat-dictionary item-key))
             (throw (ex-info (str "Missing key: " item-key " in dictionary for locale: " locale) {}))))))))

#?(:clj
   (defmacro t
     [locale-key item-key & other-args]
     (throw-for-missing-key {:enforced-locales [:en] :item-key item-key})
     `(common.i18n.translate/translate ~locale-key ~item-key ~@other-args)))
